/*
CopyRight: 2019 - ArTiBulles
Created on : 02-July-2019
Author: Arnaud Jaspard - Arnaud.jaspard@artibulles.com
Version: 1.0
Description: Creating React Icons with Frames
License : MIT
*/
import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
var name = 'ZoomOut';
var keywords = ['Search'];
var category = 'navigation';
var meta = {
  keywords: keywords,
  name: name,
  category: category,
  "class": "Icon_".concat(name)
};
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("g", {
  id: "zoom(1)",
  transform: "translate(2.000000, 2.000000)",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M54.6220408,36.9697959 L27.3110204,36.9697959 C25.0971429,36.9697959 23.3142857,38.7526531 23.3142857,40.9665306 C23.3142857,43.1804082 25.0971429,44.9632653 27.3110204,44.9632653 L54.6220408,44.9632653 C56.8359184,44.9632653 58.6187755,43.1804082 58.6187755,40.9665306 C58.6187755,38.7526531 56.8163265,36.9697959 54.6220408,36.9697959 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.9861224,73.9004082 C22.7853061,73.9004082 8.03265306,59.1673469 8.03265306,40.9665306 C8.03265306,22.7853061 22.7853061,8.03265306 40.9861224,8.03265306 C59.1869388,8.03265306 73.92,22.7853061 73.92,40.9665306 C73.92,59.1673469 59.1673469,73.9004082 40.9861224,73.9004082 Z M94.8244898,89.162449 L72.6269388,66.9844898 C78.4457143,59.9118367 81.9526531,50.8408163 81.9526531,40.9665306 C81.9526531,18.3379592 63.6146939,2.84217094e-14 40.9861224,2.84217094e-14 C18.357551,2.84217094e-14 2.84217094e-14,18.3379592 2.84217094e-14,40.9665306 C2.84217094e-14,63.595102 18.3379592,81.9330612 40.9861224,81.9330612 C50.8604082,81.9330612 59.9118367,78.4457143 66.9844898,72.6269388 L89.162449,94.8244898 C90.7297959,96.3918367 93.2571429,96.3918367 94.8244898,94.8244898 C96.3918367,93.2571429 96.3918367,90.7297959 94.8244898,89.162449 L94.8244898,89.162449 Z",
  id: "Shape"
}))), meta);